import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function AboutPage() {
  return (
    <>
      <SEO
        title="About Us"
        description="Learn about Bill Forge's mission to simplify invoicing for businesses everywhere. Customer-first approach, trust, security, and continuous innovation. Meet the team behind the best free invoicing software."
        path="/about"
      />
      <div className="bg-background">
      {/* Header */}
      <section className="py-20 bg-gradient-to-b from-primary/5 to-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold font-manrope mb-6">
            About Bill Forge
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Simplifying invoicing for businesses everywhere
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-background">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold font-manrope mb-6">Our Mission</h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              At Bill Forge, we believe that every business deserves access to professional,
              easy-to-use invoicing tools. We're on a mission to eliminate the complexity of
              billing so entrepreneurs and small businesses can focus on what they do best —
              serving their customers and growing their business.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 mt-16">
            <div className="bg-card border border-border rounded-xl p-8">
              <h3 className="text-2xl font-bold font-manrope mb-4 text-primary">
                Why We Built This
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                We experienced firsthand the frustration of managing invoices across multiple
                clients, organizations, and projects. Spreadsheets were messy, existing tools
                were either too complex or too limited, and valuable time was wasted on
                administrative tasks instead of growing the business.
              </p>
            </div>

            <div className="bg-card border border-border rounded-xl p-8">
              <h3 className="text-2xl font-bold font-manrope mb-4 text-primary">
                What We Stand For
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Simplicity, reliability, and transparency. We believe software should be intuitive
                enough to use immediately but powerful enough to scale with your business. We're
                committed to providing honest pricing, excellent support, and continuous
                improvement based on your feedback.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-card">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold font-manrope text-center mb-12">Our Values</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🎯</span>
              </div>
              <h3 className="text-xl font-bold font-manrope mb-3">Customer-First</h3>
              <p className="text-muted-foreground">
                Every feature we build starts with understanding your needs and solving real
                problems.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🔒</span>
              </div>
              <h3 className="text-xl font-bold font-manrope mb-3">Trust & Security</h3>
              <p className="text-muted-foreground">
                Your data is sacred. We invest heavily in security to protect your business
                information.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🚀</span>
              </div>
              <h3 className="text-xl font-bold font-manrope mb-3">Continuous Innovation</h3>
              <p className="text-muted-foreground">
                We're constantly improving and adding new features based on your feedback and
                industry trends.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary text-primary-foreground">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold font-manrope mb-6">
            Join Our Journey
          </h2>
          <p className="text-xl opacity-90 mb-10">
            We're just getting started. Be part of the thousands of businesses transforming their
            invoicing with Bill Forge.
          </p>
          <Link
            to="/signup"
            className="inline-block px-8 py-4 text-lg font-medium bg-background text-foreground rounded-lg hover:bg-background/90 transition-colors"
          >
            Start Free Trial
          </Link>
        </div>
      </section>
    </div>
    </>
  );
}
